import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import router from '@/router'

const environment = import.meta.env.VITE_APP_SENTRY_ENV
const dsn = import.meta.env.VITE_APP_SENTRY_DSN
export function installSentry (app) {
  Sentry.init({
    enabled: !!environment,
    app,
    dsn,
    environment,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'sso.funplus.com.cn', /^\//]
      })
    ],
    tracesSampleRate: 1.0,
    beforeSend (event, hint) {
      // Modify event here
      const originalException = hint.originalException
      if (originalException && originalException.isAxiosError && originalException.response) {
        const status = originalException.response.status
        if (status === 401) {
          return null
        }
      }
      return event
    }
  })
}
